export default "__VITE_ASSET__BRc4mYdS__"